import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

const OPERATIONS_ROUTING_PARAMS = {
  loanId: 'loanId',
  operationId: 'operationId',
};

class OperationsPaths {
  static operations = new EnhancedPath('/loans');

  static operationPage = new EnhancedPath(
    `${OperationsPaths.operations.path}/:${OPERATIONS_ROUTING_PARAMS.loanId}/operations/:${OPERATIONS_ROUTING_PARAMS.operationId}`,
  );
}

const routesConfig = {
  settings: {
    layout: {
      config: {
        toolbar: { display: true },
      },
    },
  },
  routes: [
    {
      path: OperationsPaths.operationPage.path,
      component: lazyWithRetry(() => import('app/pages/system/operations')),
      pageCode: PAGE_CODES.LOAN_APPLICATION,
    },
  ],
};

export default routesConfig;
